import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import AboutHero from "./components/AboutHero";
import CompanyStory from "./components/CompanyStory";
import BrandPhilosophy from "./components/BrandPhilosophy";
import OurCraft from "./components/OurCraft";
import ProductRange from "./components/ProductRange";
import OurFactory from "./components/OurFactory";
import AboutCTA from "./components/AboutCTA";

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <AboutHero />
        <CompanyStory />
        <BrandPhilosophy />
        <OurCraft />
        <ProductRange />
        <OurFactory />
        <AboutCTA />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
